"use strict";
/*jshint esversion: 6 */

(function() {

    /**
     *
     */

    var self = Fotobook.pages = {

        changeCurrent(page_num, dontScroll){
            if (Fotobook.book.inited &&
                Fotobook.store.getters['OnlineEditor/currentPage'] !== parseInt(page_num, 10)
            ) {
                Fotobook.store.dispatch('OnlineEditor/setCurrentPage', page_num);
                Fotobook.book.drawCurrent();

                // восстановил !!! добавляем к странице дополнительные контролы
                // а нужно ли ?
                // const bgWrapper = Fotobook.book.getCurrentPage().find('.bg-wrapper');
                // Fotobook.book.setupPageBackground.call(bgWrapper);

                Fotobook.qualityCheck.checkContainersOnPage();
                if (!dontScroll) {
                    Fotobook.bottomPanel.carousel.scrollToSelected();
                }
            }
        },

        changePage(offset) {
            if (!offset) {
                return;
            }
            var $pages_list = $(Fotobook.book.pagesList),
                $items = $pages_list.find(".carousel-item"),
                $current = $pages_list
                    .find(".book-page[data-page_num=" + Fotobook.store.getters['OnlineEditor/currentPage']+"]")
                    .closest(".carousel-item"),
                new_index = Math.max(0, Math.min($items.length - 1, $current.index() + offset)),
                page_num = Fotobook.book.getPageNumFromSpread($items.eq(new_index));

            self.changeCurrent(page_num);
        },

        changePageAttrs(params, redraw) {
            const promise = Fotobook.ajax.postJSON('/editor/page/change-attributes', {
                data: params,
            }).then((response) => {
                Fotobook.isModified = true;
                if (redraw || false) {
                    Fotobook.book.initState(response.data);
                }
            });
            promise.catch(() => null);
            return promise;
        },

        /**
         * Удалить страницу(ы) из книги
         *
         *s @param pages
         * @returns {*}
         */
        deletePages(pages) {
            return new Promise((resolve, reject) => {
                Fotobook.ajax.postJSON('/editor/page/delete', {
                    data: {
                        pages,
                    },
                }).then((response) => {
                    if (response.data.state) {
                        $(document).triggerHandler(Fotobook.events.MODIFIED, response);
                    }
                    resolve(response);
                }).catch(reject);
            });
        },

        /**
         * Добавить страницу в книгу
         *
         * @param params
         * @returns {*}
         */
        addPage(params) {
            return self._addPages('/editor/page/add', params);
        },

        /**
         * Дублировать страницу книги
         *
         * @param params
         * @returns {*}
         */
        duplicatePage(params) {
            return self._addPages('/editor/page/duplicate', params);
        },

        _addPages(url, params) {
            const promise = Fotobook.ajax.postJSON(url, {
                data: params,
            }).then((response) => {
                $(document).triggerHandler(Fotobook.events.MODIFIED, response);
                if (response.data.additional_message && response.data.additional_message[0].length) {
                    Fotobook.dialog.alert(response.data.additional_message[0], {
                        title: t('photobook-js-saveProjectDialogTitle'),
                    });
                }
            });
            promise.catch(() => null);
            return promise;
        },

        /**
         * Получить подпись страницы для отображения под ней
         * @param {jQuery} $page Объет страницы
         * @returns {*}
         */
        getPrintPageNum($page) {
            let product = Fotobook.book.product_type.code;
            if (!$page.length) {
                return '';
            }

            return Fotobook[product].getPrintPageNum($page);
        },

        /** Обновить подписи страниц в зоне редактора */
        updatePageNumbers() {
            const $book = $('#book:visible,#book-preview:visible,.single-preview:visible');
            const preview = $book.is('#book-preview');
            const singlePreview = $book.is('.single-preview');

            if (Fotobook.book.product_type.code === 'souvenir' && singlePreview) {
                // тут был код, который обновлял текст селектора сам на себя
                return;
            }

            const $pages = $book.find((preview ? '.b-p1 ' : '') + '.book-page:visible');
            const names = $pages.toArray().map(function (page) {
                return this.getPrintPageNum($(page));
            }, self);

            Fotobook.store.dispatch('OnlineEditor/setPageNumbers', names.join(' — '));
            Fotobook.store.dispatch('OnlineEditor/setPagesCount', $pages.length);
        },

        selectBadPage(){
            $(Fotobook.book.pagesList).find(".foto-container").filter(".empty,.low-quality-container,.no-original").first().click();
        },

    };
})();
